import { render } from "./DynamicHtmlI.vue?vue&type=template&id=4ab56557&ts=true"
import script from "./DynamicHtmlI.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlI.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlI.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ab56557"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ab56557', __exports__)) {
    api.reload('4ab56557', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlI.vue?vue&type=template&id=4ab56557&ts=true", () => {
    api.rerender('4ab56557', render)
  })

}


export default __exports__